import { Car } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import {
  getAppointmentDriverLabel,
  getEffectiveAppointmentDriverType,
  shouldFlipAppointmentDriverIcon,
  type AppointmentDriverType,
} from "@/lib/utils/appointment-driver";

interface AppointmentDriverBadgeProps {
  isTaxiDog?: boolean | null;
  driverType?: AppointmentDriverType | null;
  iconClassName?: string;
  showText?: boolean;
  className?: string;
}

export function AppointmentDriverBadge({
  isTaxiDog,
  driverType,
  iconClassName = "h-2.5 w-2.5",
  showText = true,
  className = "bg-white text-black border-gray-300 h-4 px-1 text-[9px] font-medium gap-0.5 shrink-0 truncate",
}: AppointmentDriverBadgeProps) {
  const { t } = useTranslation("calendar");
  const effectiveDriverType = getEffectiveAppointmentDriverType({
    driverType,
    isTaxiDog,
  });

  if (!effectiveDriverType) return null;

  const label = getAppointmentDriverLabel(effectiveDriverType, t);

  return (
    <Badge variant="outline" className={className} title={label}>
      <Car
        className={`${iconClassName} ${shouldFlipAppointmentDriverIcon(effectiveDriverType) ? "-scale-x-100" : ""}`}
        aria-hidden
      />
      {showText ? label : null}
    </Badge>
  );
}
